import { Reveal } from "./Reveal";

export const SectionHeader = ({ eyebrow, title, sub, dark = false, testid }) => (
    <Reveal className="max-w-3xl mx-auto text-center mb-14 sm:mb-16 px-6">
        <p
            className={`text-xs font-semibold uppercase tracking-[0.28em] mb-4 ${
                dark ? "text-bh-softgold" : "text-bh-gold"
            }`}
        >
            {eyebrow}
        </p>
        <h2
            data-testid={testid}
            className={`font-serif font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight ${
                dark ? "text-white" : "text-bh-deep"
            }`}
        >
            {title}
        </h2>
        <span
            aria-hidden="true"
            className="block w-14 h-[2px] bg-bh-gold mx-auto mt-6"
        />
        {sub && (
            <p
                className={`mt-5 text-base sm:text-lg leading-relaxed ${
                    dark ? "text-white/70" : "text-bh-gray"
                }`}
            >
                {sub}
            </p>
        )}
    </Reveal>
);
